/* TODO: t() */
import React, { Component } from 'react';
import DataStore from '../../support/DataStore';
import autobind from 'class-autobind';
import { StyleSheet, css } from 'aphrodite';
import cx from 'classnames';

const dataStore = DataStore.getInstance('app');

type Props = ObjectOf<unknown>;
type State = {
  ignoreAlert: boolean;
};

export default class UpdateAlert extends Component<Props, State> {
  _subscription: Subscription;

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      ignoreAlert: false,
    };
    this._subscription = dataStore.onChange('isUpdateAvailable', () => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this._subscription.unsubscribe();
  }

  render() {
    let { ignoreAlert } = this.state;
    let isUpdateAvailable = dataStore.get('isUpdateAvailable');
    if (!isUpdateAvailable || ignoreAlert) {
      return null;
    }
    return (
      <div className={css(styles.root)}>
        <span className={css(styles.text)}>
          New version available!
          <span className={css(styles.refreshText)} onClick={this._refresh}>
            Refresh now
          </span>
        </span>
        <button
          className={cx(css(styles.closeButton), 'close')}
          onClick={this._ignoreAlert}
        >
          <span>&times;</span>
        </button>
      </div>
    );
  }

  _refresh() {
    window.location.reload();
  }

  _ignoreAlert() {
    this.setState({ ignoreAlert: true });
  }
}

let styles = StyleSheet.create({
  root: {
    backgroundColor: 'rgb(235, 89, 60)',
    paddingTop: 8,
    paddingBottom: 8,
    textAlign: 'center',
  },
  text: {
    color: 'white',
  },
  refreshText: {
    marginLeft: 5,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  closeButton: {
    padding: '0 10px',
  },
});
